var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { State, Action, Selector } from '@ngxs/store';
import { EditStateModel } from './edit.state.model';
import { SetView, ShowColumns, ShowColumn, ResetEditPage, NextView, PreviousView, SetObjectVisibility, SetObjectPickable } from './edit.actions';
import { EditViewEnum } from '../models/edit-view.enum';
import { EditPaintState } from './paint/edit.paint.state';
import { RecordChapterVisibilityState, RecordChapterPickableState } from '../../story/state/chapters/story.chapters.actions';
import { ResetPaint } from './paint/edit.paint.actions';
import { ToggleVisibleNodes, TogglePickableNodes } from 'src/app/engine/state/nodes/engine.nodes.actions';
var initialState = {
    view: EditViewEnum.Chapter,
    showColumns: true,
    showLeftColumn: true,
    showRightColumn: true,
    showHeader: true,
    showFooter: true,
    record: true
};
var EditState = /** @class */ (function () {
    function EditState() {
    }
    EditState.getView = function (state) {
        return state.view;
    };
    EditState.getShowColumns = function (state) {
        return state.showColumns;
    };
    EditState.getShowLeftColumn = function (state) {
        return state.showLeftColumn;
    };
    EditState.getShowRightColumn = function (state) {
        return state.showRightColumn;
    };
    EditState.getShowHeader = function (state) {
        return state.showHeader;
    };
    EditState.getShowFooter = function (state) {
        return state.showFooter;
    };
    EditState.getRecord = function (state) {
        return state.record;
    };
    EditState.prototype.setView = function (context, action) {
        context.patchState({
            view: action.view
        });
    };
    EditState.prototype.nextView = function (context, action) {
        var view = context.getState().view;
        var views = Object.values(EditViewEnum);
        var next = views[views.indexOf(view) + 1] || views[0];
        context.patchState({
            view: next
        });
    };
    EditState.prototype.previousView = function (context, action) {
        var view = context.getState().view;
        var views = Object.values(EditViewEnum);
        var previous = views[views.indexOf(view) - 1] || views[views.length - 1];
        context.patchState({
            view: previous
        });
    };
    EditState.prototype.showColumns = function (context, action) {
        context.patchState({
            showColumns: action.show
        });
    };
    EditState.prototype.showColumn = function (context, action) {
        switch (action.column) {
            case 'left':
                context.patchState({
                    showLeftColumn: action.show
                });
                break;
            case 'right':
                context.patchState({
                    showRightColumn: action.show
                });
                break;
            case 'header':
                context.patchState({
                    showHeader: action.show
                });
                break;
            case 'footer':
                context.patchState({
                    showFooter: action.show
                });
                break;
        }
    };
    EditState.prototype.resetEditPage = function (context, action) {
        context.setState(initialState);
        context.dispatch(new ResetPaint());
    };
    EditState.prototype.setObjectVisibility = function (context, action) {
        // relay to the engine
        context.dispatch(new ToggleVisibleNodes(action.nodes, action.visible));
        // record with current chapter
        var record = context.getState().record;
        context.dispatch(new RecordChapterVisibilityState(action.nodes, action.visible, record));
    };
    EditState.prototype.setObjectPickable = function (context, action) {
        context.dispatch(new TogglePickableNodes(action.nodes, action.pickable));
        // record with current chapter
        var record = context.getState().record;
        context.dispatch(new RecordChapterPickableState(action.nodes, action.pickable, record));
    };
    __decorate([
        Action(SetView),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetView]),
        __metadata("design:returntype", void 0)
    ], EditState.prototype, "setView", null);
    __decorate([
        Action(NextView),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, NextView]),
        __metadata("design:returntype", void 0)
    ], EditState.prototype, "nextView", null);
    __decorate([
        Action(PreviousView),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, NextView]),
        __metadata("design:returntype", void 0)
    ], EditState.prototype, "previousView", null);
    __decorate([
        Action(ShowColumns),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ShowColumns]),
        __metadata("design:returntype", void 0)
    ], EditState.prototype, "showColumns", null);
    __decorate([
        Action(ShowColumn),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ShowColumn]),
        __metadata("design:returntype", void 0)
    ], EditState.prototype, "showColumn", null);
    __decorate([
        Action(ResetEditPage),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ResetEditPage]),
        __metadata("design:returntype", void 0)
    ], EditState.prototype, "resetEditPage", null);
    __decorate([
        Action(SetObjectVisibility),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetObjectVisibility]),
        __metadata("design:returntype", void 0)
    ], EditState.prototype, "setObjectVisibility", null);
    __decorate([
        Action(SetObjectPickable),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetObjectPickable]),
        __metadata("design:returntype", void 0)
    ], EditState.prototype, "setObjectPickable", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [EditStateModel]),
        __metadata("design:returntype", void 0)
    ], EditState, "getView", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [EditStateModel]),
        __metadata("design:returntype", void 0)
    ], EditState, "getShowColumns", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [EditStateModel]),
        __metadata("design:returntype", void 0)
    ], EditState, "getShowLeftColumn", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [EditStateModel]),
        __metadata("design:returntype", void 0)
    ], EditState, "getShowRightColumn", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [EditStateModel]),
        __metadata("design:returntype", void 0)
    ], EditState, "getShowHeader", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [EditStateModel]),
        __metadata("design:returntype", void 0)
    ], EditState, "getShowFooter", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [EditStateModel]),
        __metadata("design:returntype", void 0)
    ], EditState, "getRecord", null);
    EditState = __decorate([
        State({
            name: 'edit',
            defaults: initialState,
            children: [
                EditPaintState
            ]
        })
    ], EditState);
    return EditState;
}());
export { EditState };
